import { useState, type FormEvent } from 'react';
import { useAuth } from '../features/auth/AuthProvider.js';
import { toast } from '../lib/toast.js';

export function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState(import.meta.env.DEV ? 'director@cls.co.uk' : '');
  const [password, setPassword] = useState(import.meta.env.DEV ? 'password123' : '');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      await login(email, password);
    } catch (err: unknown) {
      const msg = (err as { response?: { data?: { message?: string } } })?.response?.data?.message ?? 'Login failed';
      setError(msg);
      toast('Login failed', msg, 'danger');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16, background: 'var(--bg)' }}>
      <form onSubmit={submit} style={{ width: 380, maxWidth: '100%', background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 16, padding: 28 }}>
        <div style={{ marginBottom: 18, textAlign: 'center' }}>
          <div className="logo-badge">CLS</div>
          <div className="logo-sub" style={{ marginTop: 6 }}>Logistics CRM</div>
        </div>
        <div className="modal-title" style={{ textAlign: 'center', marginBottom: 18 }}>Sign in</div>

        <div className="form-row">
          <label className="form-label">Email</label>
          <input className="form-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} autoFocus required />
        </div>

        <div className="form-row">
          <label className="form-label">Password</label>
          <input className="form-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={8} />
        </div>

        {error ? <div className="form-err show" style={{ marginBottom: 12 }}>{error}</div> : null}

        <button className="btn btn-primary" type="submit" disabled={loading} style={{ width: '100%', justifyContent: 'center' }}>
          {loading ? 'Signing in…' : 'Sign in'}
        </button>

      </form>
    </div>
  );
}
